export class ReactivateRequest {

    LicenseKey: string;
    Initials: string;
    CreditCardID: number;
    AdminID: number;

}